import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';

@Component({
  selector: 'ae-coverage-info',
  templateUrl: './coverage-info.component.html',
  styleUrls: ['./coverage-info.component.scss']
})
export class CoverageInfoComponent implements OnInit {
  constructor(private router: Router, private loaderService: LoaderService) {}

  ngOnInit(): void {
    this.loaderService.hide();
    window.scrollTo(0, 0);
  }
  nextClick() {
    this.router.navigate(['/underwriter-info']);
  }
}
